module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-search-advanced-options"
  }, [_c('button', {
    staticClass: "btn-header",
    on: {
      "click": function($event) {
        _vm.toggleMenu()
      }
    }
  }, [_c('span', [_vm._v("Advanced Options")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.menuOpen),
      expression: "!menuOpen"
    }],
    staticClass: "fa fa-chevron-down"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuOpen),
      expression: "menuOpen"
    }],
    staticClass: "fa fa-chevron-up"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuOpen),
      expression: "menuOpen"
    }],
    staticClass: "advanced-options-body"
  }, [_c('div', {
    staticClass: "option-group"
  }, [_c('div', {
    staticClass: "option-heading"
  }, [_vm._v("\n                Categories\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "option-group-list"
  }, _vm._l((_vm.sortedSelectedCategories), function(category) {
    return _c('li', {
      staticClass: "option-group-list-item"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "flex-full"
    }, [_vm._v("\n                            " + _vm._s(category.label) + "\n                        ")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.deselectCategory(category.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  })), _vm._v(" "), (_vm.selectedCategories.length === 0) ? _c('div', {
    staticClass: "option-group-list-spacer"
  }) : _vm._e(), _vm._v(" "), _c('SearchSelect', {
    ref: "categorySearchSelect",
    attrs: {
      "options": _vm.categoryOptions,
      "multiple": true,
      "value": _vm.selectedCategoryIds
    },
    on: {
      "input": function($event) {
        _vm.updateSelectedCategories($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "term-type-option-group option-group"
  }, [_c('div', {
    staticClass: "option-heading"
  }, [_vm._v("\n                Term Types\n            ")]), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "options": _vm.termTypeOptions,
      "value": _vm.selectedTermTypes
    },
    on: {
      "input": function($event) {
        _vm.updateSelectedTermTypes($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "path-option-group option-group"
  }, [_c('div', {
    staticClass: "option-heading"
  }, [_vm._v("\n                Paths\n            ")]), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "options": _vm.pathOptions,
      "value": _vm.selectedPathIds
    },
    on: {
      "input": function($event) {
        _vm.updateSelectedPaths($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "assignment-option-group option-group"
  }, [_c('div', {
    staticClass: "option-heading"
  }, [_vm._v("\n                Assignments\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "option-group-list"
  }, _vm._l((_vm.sortedSelectedAssignmentNames), function(name) {
    return _c('li', {
      staticClass: "option-group-list-item"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "name flex-full"
    }, [_vm._v("\n                            " + _vm._s(name) + "\n                        ")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.deselectAssignment(name)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  })), _vm._v(" "), (_vm.selectedAssignments.length === 0) ? _c('div', {
    staticClass: "option-group-list-spacer"
  }) : _vm._e(), _vm._v(" "), _c('SearchSelect', {
    ref: "assignmentSearchSelect",
    attrs: {
      "options": _vm.assignmentOptions,
      "multiple": true,
      "value": _vm.normalizedSelectedAssignmentNames
    },
    on: {
      "input": function($event) {
        _vm.updateSelectedAssignments($event)
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-007fef3d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ForumSearchAdvancedOptions.vue
// module id = 1954
// module chunks = 2